import React from 'react';
import PropTypes from 'prop-types';
import { injectUrlVars } from 'Utils/Validators';

export default class IframeSource extends React.Component {
  static propTypes = {
    href: PropTypes.string,
    onOpenContact: PropTypes.func,
    background: PropTypes.string,
    deeplinkId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  };

  constructor(props) {
    super(props);

    this.state = {
      iframeHeight: props.pageId === 180 ? 1624 : 1024, // default iframeHeight
      iframeScrollPos: 0, // default iframeHeight
    };

    this.handlePostMessage = this.handlePostMessage.bind(this);
    // The Verti Iframe has to scrolled to top after changing the height.
    this.isVertiIframe = props.href && props.href.indexOf('verti.de') > -1;

    if (window.location.pathname.indexOf('gebrauchtwagenbewertung/zusammenfassung') > -1) {
      window.guid = window.location.pathname.substr(
        window.location.pathname.indexOf('zusammenfassung/') + 16,
        window.location.pathname.length - 1
      );
    }
  }

  onClick = () => {
    this.props.onOpenContact();
  };

  componentDidMount = () => {
    window.addEventListener('message', this.handlePostMessage);
  };

  componentWillUnmount = () => {
    window.removeEventListener('message', this.handlePostMessage);
  };

  handlePostMessage = (event) => {
    if (event.data && event.data.request) {
      switch (event.data.request) {
        case 'setIframeHeight':
          this.setState(
            { iframeHeight: event.data.payload },
            () => this.isVertiIframe && window.scrollTo(0, 0)
          );

          break;
        case 'setScrollPosition':
          window.scrollTo(0, event.data.payload);

          break;
        case 'getOffsetTop':
          break;
        default:
          console.log('handlePostMessage Error');
      }
    }
  };

  render() {
    return (
      <div className={this.props.background} id={this.props.deeplinkId}>
        <div
          dangerouslySetInnerHTML={{
            __html: `<iframe src=${injectUrlVars(
              this.props.href
            )} width="100%" height="100%" id="externContent" style="border: none"/>`,
          }}
          style={{ height: this.state.iframeHeight + 'px', border: 'none' }}
        />
      </div>
    );
  }
}
